import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
  .container {
    display: flex;
    height: 6.2rem;
    align-items: center;
    justify-content: center;
    border: 2px solid ${colors.governorBayBlue};
    text-decoration: none;
    padding: 0 2rem;
    transition: opacity 150ms ease;
    overflow: hidden;
  }

  .container:hover {
    opacity: 0.6;
  }

  .container:active {
    opacity: 0.3;
  }

  :global(.icon) {
    height: 2rem;
  }

  :global(.icon img) {
    height: 100%;
  }

  .label {
    ${common.title};

    font-family: 'Open Sans Bold', sans-serif;
    color: ${colors.governorBayBlue};
    display: block;
    margin-left: 1.4rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      height: 5.4rem;
      border: 1.5px solid ${colors.governorBayBlue};
      text-decoration: none;
      padding: 0 1.6rem;
    }

    :global(.icon) {
      height: 1.6rem;
    }

    .label {
      ${common.text};
    }
  }

  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {
    .label {
      display: none;
    }
  }
`
